export default Object.freeze({
  LOGIN: 'LOGIN',
  LOAD_USER_INFO: 'LOAD_USER_INFO',
  LOGOUT: 'LOGOUT',
  UPDATE_AUTH_TOKEN: 'UPDATE_AUTH_TOKEN',
  SET_AUTH_INFO: 'SET_AUTH_INFO',
  SET_AUTH_TOKEN: 'SET_AUTH_TOKEN',
  SET_REFRESH_TOKEN: 'SET_REFRESH_TOKEN',
  REFRESH_AUTH_TOKEN: 'REFRESH_AUTH_TOKEN',

  // SET_ACTIVE_PROJECT: 'SET_ACTIVE_PROJECT',
  // LOGIN_OAUTH: 'LOGIN_OAUTH',

});
